$(document).on('click', '.mrk-addon-dropdown-item', function () {
    $(this)
    .closest('.mrk-frame-cart-addon-inner')
    .find('.mrk-cart-frame-add')
    .trigger('click');
});

 
(function () {
  function syncUpsellToProgressBar() {
    requestAnimationFrame(() => {
      const upsellSource = document.querySelector('.mrk-upsell-wrapper');
      const progressBarTarget = document.querySelector('.wd-collection-progress-bar');
 
      if (!upsellSource) return; // upsell block not present on this page
      if (!progressBarTarget) return; // progress bar not present
 
      // Replace the inner content of the progress bar with the upsell HTML
      progressBarTarget.innerHTML = upsellSource.innerHTML;
    });
  }
 
  // Fires in the `finally` block of updateQuantity — always runs after fetch
  document.addEventListener('cart:updated', syncUpsellToProgressBar);
 
  // Also run once on page load so the initial state is in sync
  document.addEventListener('DOMContentLoaded', syncUpsellToProgressBar);
})();
 

